import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { EuiInputPopover, EuiHorizontalRule, EuiText, EuiTitle, EuiLoadingSpinner, EuiStat, EuiDatePickerRange, EuiButtonEmpty, EuiModal, EuiCard, EuiComboBox, EuiButtonIcon, EuiLink, EuiGlobalToastList, EuiFieldPassword, EuiFormRow, EuiButton, EuiButtonGroup } from '@elastic/eui';
export { EuiAccordion as Accordion, EuiAvatar as Avatar, EuiBadge as Badge, EuiBasicTable as BasicTable, EuiBetaBadge as BetaBadge, EuiBottomBar as BottomBar, CENTER_ALIGNMENT, EuiCallOut as CallOut, EuiCheckbox as Checkbox, EuiCheckboxGroup as CheckboxGroup, EuiCollapsibleNav as CollapsibleNav, EuiCollapsibleNavGroup as CollapsibleNavGroup, EuiConfirmModal as ConfirmModal, EuiContextMenu as ContextMenu, EuiContextMenuItem as ContextMenuItem, EuiContextMenuPanel as ContextMenuPanel, EuiCopy as Copy, EuiDatePicker as DatePicker, EuiDescribedFormGroup as DescribedFormGroup, EuiDescriptionList as DescriptionList, EuiDescriptionListDescription as DescriptionListDescription, EuiDescriptionListTitle as DescriptionListTitle, EuiDragDropContext as DragDropContext, EuiDraggable as Draggable, EuiDroppable as Droppable, EuiEmptyPrompt as EmptyPrompt, EuiFacetButton as FacetButton, EuiFieldNumber as FieldNumber, EuiFieldSearch as FieldSearch, EuiFieldText as FieldText, EuiFilePicker as FilePicker, EuiFilterButton as FilterButton, EuiFilterGroup as FilterGroup, EuiFilterSelectItem as FilterSelectItem, EuiFlexGrid as FlexGrid, EuiFlexGroup as FlexGroup, EuiFlexItem as FlexItem, EuiFlyout as Flyout, EuiFlyoutBody as FlyoutBody, EuiFlyoutFooter as FlyoutFooter, EuiFlyoutHeader as FlyoutHeader, EuiFocusTrap as FocusTrap, EuiForm as Form, EuiFormControlLayout as FormControlLayout, EuiFormControlLayoutDelimited as FormControlLayoutDelimited, EuiGlobalToastList as GlobalToastList, EuiHeader as Header, EuiHeaderBreadcrumbs as HeaderBreadcrumbs, EuiHeaderLink as HeaderLink, EuiHeaderLogo as HeaderLogo, EuiHeaderSectionItem as HeaderSectionItem, EuiHeaderSectionItemButton as HeaderSectionItemButton, EuiHealth as Health, EuiHighlight as Highlight, EuiHorizontalRule as HorizontalRule, EuiIcon as Icon, EuiIconTip as IconTip, EuiInMemoryTable as InMemoryTable, EuiKeyPadMenu as KeyPadMenu, EuiKeyPadMenuItem as KeyPadMenuItem, LEFT_ALIGNMENT, EuiListGroupItem as ListGroupItem, EuiLoadingChart as LoadingChart, EuiLoadingContent as LoadingContent, EuiLoadingSpinner as LoadingSpinner, EuiModalBody as ModalBody, EuiModalFooter as ModalFooter, EuiModalHeader as ModalHeader, EuiModalHeaderTitle as ModalHeaderTitle, EuiNotificationBadge as NotificationBadge, EuiOverlayMask as OverlayMask, EuiPage as Page, EuiPageBody as PageBody, EuiPageContent as PageContent, EuiPageContentBody as PageContentBody, EuiPageContentHeader as PageContentHeader, EuiPageContentHeaderSection as PageContentHeaderSection, EuiPageHeader as PageHeader, EuiPageHeaderSection as PageHeaderSection, EuiPageSideBar as PageSideBar, EuiPageTemplate as PageTemplate, EuiPagination as Pagination, EuiPanel as Panel, EuiPinnableListGroup as PinnableListGroup, EuiPopover as Popover, EuiPopoverFooter as PopoverFooter, EuiPopoverTitle as PopoverTitle, EuiPortal as Portal, EuiProgress as Progress, RIGHT_ALIGNMENT, EuiRadio as Radio, EuiRadioGroup as RadioGroup, EuiSelect as Select, EuiShowFor as ShowFor, EuiSpacer as Spacer, EuiSplitPanel as SplitPanel, EuiSteps as Steps, EuiStepsHorizontal as StepsHorizontal, EuiSuperSelect as SuperSelect, EuiSwitch as Switch, EuiTab as Tab, EuiTabbedContent as TabbedContent, EuiTabs as Tabs, EuiText as Text, EuiTextArea as TextArea, EuiTitle as Title, EuiToolTip as ToolTip, euiDragDropReorder as dragDropReorder, euiPaletteColorBlind, euiPaletteColorBlindBehindText, htmlIdGenerator } from '@elastic/eui';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import React, { useState } from 'react';
export { default as InfiniteScroll } from 'react-infinite-scroll-component';
export { default as Slider } from 'react-slick';
import * as solid from '@heroicons/react/solid';
export { solid as Solid };
import * as outline from '@heroicons/react/outline';
export { outline as Outline };
import '@fullcalendar/react/dist/vdom';
export { default as FullCalendar } from '@fullcalendar/react';
export { default as DayGridPlugin } from '@fullcalendar/daygrid';
export { default as TimeGridPlugin } from '@fullcalendar/timegrid';
export { default as InteractionPlugin } from '@fullcalendar/interaction';
export { Calendar } from '@fullcalendar/core';
export { default as Skeleton, SkeletonTheme } from 'react-loading-skeleton';
import Img from 'react-cool-img';
import { appendIconComponentCache } from '@elastic/eui/es/components/icon/icon';
import { icon } from '@elastic/eui/es/components/icon/assets/accessibility';
import { icon as icon$1 } from '@elastic/eui/es/components/icon/assets/app_add_data';
import { icon as icon$2 } from '@elastic/eui/es/components/icon/assets/app_advanced_settings';
import { icon as icon$3 } from '@elastic/eui/es/components/icon/assets/app_fleet';
import { icon as icon$4 } from '@elastic/eui/es/components/icon/assets/aggregate';
import { icon as icon$5 } from '@elastic/eui/es/components/icon/assets/alert';
import { icon as icon$6 } from '@elastic/eui/es/components/icon/assets/analyzeEvent';
import { icon as icon$7 } from '@elastic/eui/es/components/icon/assets/annotation';
import { icon as icon$8 } from '@elastic/eui/es/components/icon/assets/app_apm';
import { icon as icon$9 } from '@elastic/eui/es/components/icon/assets/apm_trace';
import { icon as icon$a } from '@elastic/eui/es/components/icon/assets/app_app_search';
import { icon as icon$b } from '@elastic/eui/es/components/icon/assets/apps';
import { icon as icon$c } from '@elastic/eui/es/components/icon/assets/arrow_down';
import { icon as icon$d } from '@elastic/eui/es/components/icon/assets/arrow_left';
import { icon as icon$e } from '@elastic/eui/es/components/icon/assets/arrow_right';
import { icon as icon$f } from '@elastic/eui/es/components/icon/assets/arrow_up';
import { icon as icon$g } from '@elastic/eui/es/components/icon/assets/asterisk';
import { icon as icon$h } from '@elastic/eui/es/components/icon/assets/app_auditbeat';
import { icon as icon$i } from '@elastic/eui/es/components/icon/assets/beaker';
import { icon as icon$j } from '@elastic/eui/es/components/icon/assets/bell';
import { icon as icon$k } from '@elastic/eui/es/components/icon/assets/bellSlash';
import { icon as icon$l } from '@elastic/eui/es/components/icon/assets/bolt';
import { icon as icon$m } from '@elastic/eui/es/components/icon/assets/boxes_horizontal';
import { icon as icon$n } from '@elastic/eui/es/components/icon/assets/boxes_vertical';
import { icon as icon$o } from '@elastic/eui/es/components/icon/assets/branch';
import { icon as icon$p } from '@elastic/eui/es/components/icon/assets/broom';
import { icon as icon$q } from '@elastic/eui/es/components/icon/assets/brush';
import { icon as icon$r } from '@elastic/eui/es/components/icon/assets/bug';
import { icon as icon$s } from '@elastic/eui/es/components/icon/assets/bullseye';
import { icon as icon$t } from '@elastic/eui/es/components/icon/assets/calendar';
import { icon as icon$u } from '@elastic/eui/es/components/icon/assets/app_canvas';
import { icon as icon$v } from '@elastic/eui/es/components/icon/assets/check';
import { icon as icon$w } from '@elastic/eui/es/components/icon/assets/checkInCircleFilled';
import { icon as icon$x } from '@elastic/eui/es/components/icon/assets/cheer';
import { icon as icon$y } from '@elastic/eui/es/components/icon/assets/ml_classification_job';
import { icon as icon$z } from '@elastic/eui/es/components/icon/assets/clock';
import { icon as icon$A } from '@elastic/eui/es/components/icon/assets/cloudDrizzle';
import { icon as icon$B } from '@elastic/eui/es/components/icon/assets/cloudStormy';
import { icon as icon$C } from '@elastic/eui/es/components/icon/assets/cloudSunny';
import { icon as icon$D } from '@elastic/eui/es/components/icon/assets/app_code';
import { icon as icon$E } from '@elastic/eui/es/components/icon/assets/color';
import { icon as icon$F } from '@elastic/eui/es/components/icon/assets/compute';
import { icon as icon$G } from '@elastic/eui/es/components/icon/assets/console';
import { icon as icon$H } from '@elastic/eui/es/components/icon/assets/app_console';
import { icon as icon$I } from '@elastic/eui/es/components/icon/assets/continuityAbove';
import { icon as icon$J } from '@elastic/eui/es/components/icon/assets/continuityAboveBelow';
import { icon as icon$K } from '@elastic/eui/es/components/icon/assets/continuityBelow';
import { icon as icon$L } from '@elastic/eui/es/components/icon/assets/continuityWithin';
import { icon as icon$M } from '@elastic/eui/es/components/icon/assets/controls_horizontal';
import { icon as icon$N } from '@elastic/eui/es/components/icon/assets/controls_vertical';
import { icon as icon$O } from '@elastic/eui/es/components/icon/assets/copy';
import { icon as icon$P } from '@elastic/eui/es/components/icon/assets/copy_clipboard';
import { icon as icon$Q } from '@elastic/eui/es/components/icon/assets/ml_create_advanced_job';
import { icon as icon$R } from '@elastic/eui/es/components/icon/assets/ml_create_multi_metric_job';
import { icon as icon$S } from '@elastic/eui/es/components/icon/assets/ml_create_population_job';
import { icon as icon$T } from '@elastic/eui/es/components/icon/assets/ml_create_single_metric_job';
import { icon as icon$U } from '@elastic/eui/es/components/icon/assets/cross';
import { icon as icon$V } from '@elastic/eui/es/components/icon/assets/app_cross_cluster_replication';
import { icon as icon$W } from '@elastic/eui/es/components/icon/assets/crossInACircleFilled';
import { icon as icon$X } from '@elastic/eui/es/components/icon/assets/crosshairs';
import { icon as icon$Y } from '@elastic/eui/es/components/icon/assets/currency';
import { icon as icon$Z } from '@elastic/eui/es/components/icon/assets/cut';
import { icon as icon$_ } from '@elastic/eui/es/components/icon/assets/app_dashboard';
import { icon as icon$$ } from '@elastic/eui/es/components/icon/assets/ml_data_visualizer';
import { icon as icon$10 } from '@elastic/eui/es/components/icon/assets/database';
import { icon as icon$11 } from '@elastic/eui/es/components/icon/assets/app_devtools';
import { icon as icon$12 } from '@elastic/eui/es/components/icon/assets/app_discover';
import { icon as icon$13 } from '@elastic/eui/es/components/icon/assets/document';
import { icon as icon$14 } from '@elastic/eui/es/components/icon/assets/documentEdit';
import { icon as icon$15 } from '@elastic/eui/es/components/icon/assets/documentation';
import { icon as icon$16 } from '@elastic/eui/es/components/icon/assets/documents';
import { icon as icon$17 } from '@elastic/eui/es/components/icon/assets/dot';
import { icon as icon$18 } from '@elastic/eui/es/components/icon/assets/download';
import { icon as icon$19 } from '@elastic/eui/es/components/icon/assets/editor_align_center';
import { icon as icon$1a } from '@elastic/eui/es/components/icon/assets/editor_align_left';
import { icon as icon$1b } from '@elastic/eui/es/components/icon/assets/editor_align_right';
import { icon as icon$1c } from '@elastic/eui/es/components/icon/assets/editor_bold';
import { icon as icon$1d } from '@elastic/eui/es/components/icon/assets/editor_code_block';
import { icon as icon$1e } from '@elastic/eui/es/components/icon/assets/editor_comment';
import { icon as icon$1f } from '@elastic/eui/es/components/icon/assets/editorDistributeHorizontal';
import { icon as icon$1g } from '@elastic/eui/es/components/icon/assets/editorDistributeVertical';
import { icon as icon$1h } from '@elastic/eui/es/components/icon/assets/editor_heading';
import { icon as icon$1i } from '@elastic/eui/es/components/icon/assets/editor_italic';
import { icon as icon$1j } from '@elastic/eui/es/components/icon/assets/editorItemAlignBottom';
import { icon as icon$1k } from '@elastic/eui/es/components/icon/assets/editorItemAlignCenter';
import { icon as icon$1l } from '@elastic/eui/es/components/icon/assets/editorItemAlignLeft';
import { icon as icon$1m } from '@elastic/eui/es/components/icon/assets/editorItemAlignMiddle';
import { icon as icon$1n } from '@elastic/eui/es/components/icon/assets/editorItemAlignRight';
import { icon as icon$1o } from '@elastic/eui/es/components/icon/assets/editorItemAlignTop';
import { icon as icon$1p } from '@elastic/eui/es/components/icon/assets/editor_link';
import { icon as icon$1q } from '@elastic/eui/es/components/icon/assets/editor_ordered_list';
import { icon as icon$1r } from '@elastic/eui/es/components/icon/assets/editorPositionBottomLeft';
import { icon as icon$1s } from '@elastic/eui/es/components/icon/assets/editorPositionBottomRight';
import { icon as icon$1t } from '@elastic/eui/es/components/icon/assets/editorPositionTopLeft';
import { icon as icon$1u } from '@elastic/eui/es/components/icon/assets/editorPositionTopRight';
import { icon as icon$1v } from '@elastic/eui/es/components/icon/assets/editor_redo';
import { icon as icon$1w } from '@elastic/eui/es/components/icon/assets/editor_strike';
import { icon as icon$1x } from '@elastic/eui/es/components/icon/assets/editor_table';
import { icon as icon$1y } from '@elastic/eui/es/components/icon/assets/editor_underline';
import { icon as icon$1z } from '@elastic/eui/es/components/icon/assets/editor_undo';
import { icon as icon$1A } from '@elastic/eui/es/components/icon/assets/editor_unordered_list';
import { icon as icon$1B } from '@elastic/eui/es/components/icon/assets/email';
import { icon as icon$1C } from '@elastic/eui/es/components/icon/assets/empty';
import { icon as icon$1D } from '@elastic/eui/es/components/icon/assets/app_ems';
import { icon as icon$1E } from '@elastic/eui/es/components/icon/assets/eql';
import { icon as icon$1F } from '@elastic/eui/es/components/icon/assets/eraser';
import { icon as icon$1G } from '@elastic/eui/es/components/icon/assets/exit';
import { icon as icon$1H } from '@elastic/eui/es/components/icon/assets/expand';
import { icon as icon$1I } from '@elastic/eui/es/components/icon/assets/expandMini';
import { icon as icon$1J } from '@elastic/eui/es/components/icon/assets/export';
import { icon as icon$1K } from '@elastic/eui/es/components/icon/assets/eye';
import { icon as icon$1L } from '@elastic/eui/es/components/icon/assets/eye_closed';
import { icon as icon$1M } from '@elastic/eui/es/components/icon/assets/face_happy';
import { icon as icon$1N } from '@elastic/eui/es/components/icon/assets/face_neutral';
import { icon as icon$1O } from '@elastic/eui/es/components/icon/assets/face_sad';
import { icon as icon$1P } from '@elastic/eui/es/components/icon/assets/app_filebeat';
import { icon as icon$1Q } from '@elastic/eui/es/components/icon/assets/filter';
import { icon as icon$1R } from '@elastic/eui/es/components/icon/assets/flag';
import { icon as icon$1S } from '@elastic/eui/es/components/icon/assets/app_agent';
import { icon as icon$1T } from '@elastic/eui/es/components/icon/assets/fold';
import { icon as icon$1U } from '@elastic/eui/es/components/icon/assets/folder_check';
import { icon as icon$1V } from '@elastic/eui/es/components/icon/assets/folder_closed';
import { icon as icon$1W } from '@elastic/eui/es/components/icon/assets/folder_exclamation';
import { icon as icon$1X } from '@elastic/eui/es/components/icon/assets/folder_open';
import { icon as icon$1Y } from '@elastic/eui/es/components/icon/assets/frameNext';
import { icon as icon$1Z } from '@elastic/eui/es/components/icon/assets/framePrevious';
import { icon as icon$1_ } from '@elastic/eui/es/components/icon/assets/full_screen';
import { icon as icon$1$ } from '@elastic/eui/es/components/icon/assets/fullScreenExit';
import { icon as icon$20 } from '@elastic/eui/es/components/icon/assets/function';
import { icon as icon$21 } from '@elastic/eui/es/components/icon/assets/gear';
import { icon as icon$22 } from '@elastic/eui/es/components/icon/assets/app_gis';
import { icon as icon$23 } from '@elastic/eui/es/components/icon/assets/glasses';
import { icon as icon$24 } from '@elastic/eui/es/components/icon/assets/globe';
import { icon as icon$25 } from '@elastic/eui/es/components/icon/assets/grab';
import { icon as icon$26 } from '@elastic/eui/es/components/icon/assets/grab_horizontal';
import { icon as icon$27 } from '@elastic/eui/es/components/icon/assets/app_graph';
import { icon as icon$28 } from '@elastic/eui/es/components/icon/assets/grid';
import { icon as icon$29 } from '@elastic/eui/es/components/icon/assets/app_grok';
import { icon as icon$2a } from '@elastic/eui/es/components/icon/assets/heart';
import { icon as icon$2b } from '@elastic/eui/es/components/icon/assets/app_heartbeat';
import { icon as icon$2c } from '@elastic/eui/es/components/icon/assets/heatmap';
import { icon as icon$2d } from '@elastic/eui/es/components/icon/assets/help';
import { icon as icon$2e } from '@elastic/eui/es/components/icon/assets/home';
import { icon as icon$2f } from '@elastic/eui/es/components/icon/assets/iInCircle';
import { icon as icon$2g } from '@elastic/eui/es/components/icon/assets/image';
import { icon as icon$2h } from '@elastic/eui/es/components/icon/assets/import';
import { icon as icon$2i } from '@elastic/eui/es/components/icon/assets/index_close';
import { icon as icon$2j } from '@elastic/eui/es/components/icon/assets/index_edit';
import { icon as icon$2k } from '@elastic/eui/es/components/icon/assets/index_flush';
import { icon as icon$2l } from '@elastic/eui/es/components/icon/assets/app_index_management';
import { icon as icon$2m } from '@elastic/eui/es/components/icon/assets/index_mapping';
import { icon as icon$2n } from '@elastic/eui/es/components/icon/assets/index_open';
import { icon as icon$2o } from '@elastic/eui/es/components/icon/assets/app_index_pattern';
import { icon as icon$2p } from '@elastic/eui/es/components/icon/assets/app_index_rollup';
import { icon as icon$2q } from '@elastic/eui/es/components/icon/assets/index_runtime';
import { icon as icon$2r } from '@elastic/eui/es/components/icon/assets/index_settings';
import { icon as icon$2s } from '@elastic/eui/es/components/icon/assets/inputOutput';
import { icon as icon$2t } from '@elastic/eui/es/components/icon/assets/inspect';
import { icon as icon$2u } from '@elastic/eui/es/components/icon/assets/invert';
import { icon as icon$2v } from '@elastic/eui/es/components/icon/assets/ip';
import { icon as icon$2w } from '@elastic/eui/es/components/icon/assets/keyboard_shortcut';
import { icon as icon$2x } from '@elastic/eui/es/components/icon/assets/kql_field';
import { icon as icon$2y } from '@elastic/eui/es/components/icon/assets/kql_function';
import { icon as icon$2z } from '@elastic/eui/es/components/icon/assets/kql_operand';
import { icon as icon$2A } from '@elastic/eui/es/components/icon/assets/kql_selector';
import { icon as icon$2B } from '@elastic/eui/es/components/icon/assets/kql_value';
import { icon as icon$2C } from '@elastic/eui/es/components/icon/assets/layers';
import { icon as icon$2D } from '@elastic/eui/es/components/icon/assets/app_lens';
import { icon as icon$2E } from '@elastic/eui/es/components/icon/assets/link';
import { icon as icon$2F } from '@elastic/eui/es/components/icon/assets/list';
import { icon as icon$2G } from '@elastic/eui/es/components/icon/assets/list_add';
import { icon as icon$2H } from '@elastic/eui/es/components/icon/assets/lock';
import { icon as icon$2I } from '@elastic/eui/es/components/icon/assets/lockOpen';
import { icon as icon$2J } from '@elastic/eui/es/components/icon/assets/logo_aws';
import { icon as icon$2K } from '@elastic/eui/es/components/icon/assets/logo_aws_mono';
import { icon as icon$2L } from '@elastic/eui/es/components/icon/assets/logo_aerospike';
import { icon as icon$2M } from '@elastic/eui/es/components/icon/assets/logo_apache';
import { icon as icon$2N } from '@elastic/eui/es/components/icon/assets/logo_app_search';
import { icon as icon$2O } from '@elastic/eui/es/components/icon/assets/logo_azure';
import { icon as icon$2P } from '@elastic/eui/es/components/icon/assets/logo_azure_mono';
import { icon as icon$2Q } from '@elastic/eui/es/components/icon/assets/logo_beats';
import { icon as icon$2R } from '@elastic/eui/es/components/icon/assets/logo_business_analytics';
import { icon as icon$2S } from '@elastic/eui/es/components/icon/assets/logo_ceph';
import { icon as icon$2T } from '@elastic/eui/es/components/icon/assets/logo_cloud';
import { icon as icon$2U } from '@elastic/eui/es/components/icon/assets/logo_cloud_ece';
import { icon as icon$2V } from '@elastic/eui/es/components/icon/assets/logo_code';
import { icon as icon$2W } from '@elastic/eui/es/components/icon/assets/logo_codesandbox';
import { icon as icon$2X } from '@elastic/eui/es/components/icon/assets/logo_couchbase';
import { icon as icon$2Y } from '@elastic/eui/es/components/icon/assets/logo_docker';
import { icon as icon$2Z } from '@elastic/eui/es/components/icon/assets/logo_dropwizard';
import { icon as icon$2_ } from '@elastic/eui/es/components/icon/assets/logo_elastic';
import { icon as icon$2$ } from '@elastic/eui/es/components/icon/assets/logo_elastic_stack';
import { icon as icon$30 } from '@elastic/eui/es/components/icon/assets/logo_elasticsearch';
import { icon as icon$31 } from '@elastic/eui/es/components/icon/assets/logo_enterprise_search';
import { icon as icon$32 } from '@elastic/eui/es/components/icon/assets/logo_etcd';
import { icon as icon$33 } from '@elastic/eui/es/components/icon/assets/logo_gcp';
import { icon as icon$34 } from '@elastic/eui/es/components/icon/assets/logo_gcp_mono';
import { icon as icon$35 } from '@elastic/eui/es/components/icon/assets/logo_github';
import { icon as icon$36 } from '@elastic/eui/es/components/icon/assets/logo_gmail';
import { icon as icon$37 } from '@elastic/eui/es/components/icon/assets/logo_golang';
import { icon as icon$38 } from '@elastic/eui/es/components/icon/assets/logo_google_g';
import { icon as icon$39 } from '@elastic/eui/es/components/icon/assets/logo_haproxy';
import { icon as icon$3a } from '@elastic/eui/es/components/icon/assets/logo_ibm';
import { icon as icon$3b } from '@elastic/eui/es/components/icon/assets/logo_ibm_mono';
import { icon as icon$3c } from '@elastic/eui/es/components/icon/assets/logo_kafka';
import { icon as icon$3d } from '@elastic/eui/es/components/icon/assets/logo_kibana';
import { icon as icon$3e } from '@elastic/eui/es/components/icon/assets/logo_kubernetes';
import { icon as icon$3f } from '@elastic/eui/es/components/icon/assets/logo_logging';
import { icon as icon$3g } from '@elastic/eui/es/components/icon/assets/logo_logstash';
import { icon as icon$3h } from '@elastic/eui/es/components/icon/assets/logo_maps';
import { icon as icon$3i } from '@elastic/eui/es/components/icon/assets/logo_memcached';
import { icon as icon$3j } from '@elastic/eui/es/components/icon/assets/logo_metrics';
import { icon as icon$3k } from '@elastic/eui/es/components/icon/assets/logo_mongodb';
import { icon as icon$3l } from '@elastic/eui/es/components/icon/assets/logo_mysql';
import { icon as icon$3m } from '@elastic/eui/es/components/icon/assets/logo_nginx';
import { icon as icon$3n } from '@elastic/eui/es/components/icon/assets/logo_observability';
import { icon as icon$3o } from '@elastic/eui/es/components/icon/assets/logo_osquery';
import { icon as icon$3p } from '@elastic/eui/es/components/icon/assets/logo_php';
import { icon as icon$3q } from '@elastic/eui/es/components/icon/assets/logo_postgres';
import { icon as icon$3r } from '@elastic/eui/es/components/icon/assets/logo_prometheus';
import { icon as icon$3s } from '@elastic/eui/es/components/icon/assets/logo_rabbitmq';
import { icon as icon$3t } from '@elastic/eui/es/components/icon/assets/logo_redis';
import { icon as icon$3u } from '@elastic/eui/es/components/icon/assets/logo_security';
import { icon as icon$3v } from '@elastic/eui/es/components/icon/assets/logo_site_search';
import { icon as icon$3w } from '@elastic/eui/es/components/icon/assets/logo_sketch';
import { icon as icon$3x } from '@elastic/eui/es/components/icon/assets/logo_slack';
import { icon as icon$3y } from '@elastic/eui/es/components/icon/assets/logo_uptime';
import { icon as icon$3z } from '@elastic/eui/es/components/icon/assets/logo_webhook';
import { icon as icon$3A } from '@elastic/eui/es/components/icon/assets/logo_windows';
import { icon as icon$3B } from '@elastic/eui/es/components/icon/assets/logo_workplace_search';
import { icon as icon$3C } from '@elastic/eui/es/components/icon/assets/app_logs';
import { icon as icon$3D } from '@elastic/eui/es/components/icon/assets/logstash_filter';
import { icon as icon$3E } from '@elastic/eui/es/components/icon/assets/logstash_if';
import { icon as icon$3F } from '@elastic/eui/es/components/icon/assets/logstash_input';
import { icon as icon$3G } from '@elastic/eui/es/components/icon/assets/logstash_output';
import { icon as icon$3H } from '@elastic/eui/es/components/icon/assets/logstash_queue';
import { icon as icon$3I } from '@elastic/eui/es/components/icon/assets/app_ml';
import { icon as icon$3J } from '@elastic/eui/es/components/icon/assets/magnet';
import { icon as icon$3K } from '@elastic/eui/es/components/icon/assets/magnifyWithMinus';
import { icon as icon$3L } from '@elastic/eui/es/components/icon/assets/magnifyWithPlus';
import { icon as icon$3M } from '@elastic/eui/es/components/icon/assets/app_management';
import { icon as icon$3N } from '@elastic/eui/es/components/icon/assets/map_marker';
import { icon as icon$3O } from '@elastic/eui/es/components/icon/assets/memory';
import { icon as icon$3P } from '@elastic/eui/es/components/icon/assets/menu';
import { icon as icon$3Q } from '@elastic/eui/es/components/icon/assets/menuDown';
import { icon as icon$3R } from '@elastic/eui/es/components/icon/assets/menuLeft';
import { icon as icon$3S } from '@elastic/eui/es/components/icon/assets/menuRight';
import { icon as icon$3T } from '@elastic/eui/es/components/icon/assets/menuUp';
import { icon as icon$3U } from '@elastic/eui/es/components/icon/assets/merge';
import { icon as icon$3V } from '@elastic/eui/es/components/icon/assets/app_metricbeat';
import { icon as icon$3W } from '@elastic/eui/es/components/icon/assets/app_metrics';
import { icon as icon$3X } from '@elastic/eui/es/components/icon/assets/minimize';
import { icon as icon$3Y } from '@elastic/eui/es/components/icon/assets/minus';
import { icon as icon$3Z } from '@elastic/eui/es/components/icon/assets/minus_in_circle';
import { icon as icon$3_ } from '@elastic/eui/es/components/icon/assets/minus_in_circle_filled';
import { icon as icon$3$ } from '@elastic/eui/es/components/icon/assets/mobile';
import { icon as icon$40 } from '@elastic/eui/es/components/icon/assets/app_monitoring';
import { icon as icon$41 } from '@elastic/eui/es/components/icon/assets/moon';
import { icon as icon$42 } from '@elastic/eui/es/components/icon/assets/nested';
import { icon as icon$43 } from '@elastic/eui/es/components/icon/assets/node';
import { icon as icon$44 } from '@elastic/eui/es/components/icon/assets/app_notebook';
import { icon as icon$45 } from '@elastic/eui/es/components/icon/assets/number';
import { icon as icon$46 } from '@elastic/eui/es/components/icon/assets/offline';
import { icon as icon$47 } from '@elastic/eui/es/components/icon/assets/online';
import { icon as icon$48 } from '@elastic/eui/es/components/icon/assets/ml_outlier_detection_job';
import { icon as icon$49 } from '@elastic/eui/es/components/icon/assets/package';
import { icon as icon$4a } from '@elastic/eui/es/components/icon/assets/app_packetbeat';
import { icon as icon$4b } from '@elastic/eui/es/components/icon/assets/pageSelect';
import { icon as icon$4c } from '@elastic/eui/es/components/icon/assets/pagesSelect';
import { icon as icon$4d } from '@elastic/eui/es/components/icon/assets/paper_clip';
import { icon as icon$4e } from '@elastic/eui/es/components/icon/assets/partial';
import { icon as icon$4f } from '@elastic/eui/es/components/icon/assets/pause';
import { icon as icon$4g } from '@elastic/eui/es/components/icon/assets/pencil';
import { icon as icon$4h } from '@elastic/eui/es/components/icon/assets/percent';
import { icon as icon$4i } from '@elastic/eui/es/components/icon/assets/pin';
import { icon as icon$4j } from '@elastic/eui/es/components/icon/assets/pin_filled';
import { icon as icon$4k } from '@elastic/eui/es/components/icon/assets/app_pipeline';
import { icon as icon$4l } from '@elastic/eui/es/components/icon/assets/play';
import { icon as icon$4m } from '@elastic/eui/es/components/icon/assets/playFilled';
import { icon as icon$4n } from '@elastic/eui/es/components/icon/assets/plus';
import { icon as icon$4o } from '@elastic/eui/es/components/icon/assets/plus_in_circle';
import { icon as icon$4p } from '@elastic/eui/es/components/icon/assets/plus_in_circle_filled';
import { icon as icon$4q } from '@elastic/eui/es/components/icon/assets/popout';
import { icon as icon$4r } from '@elastic/eui/es/components/icon/assets/push';
import { icon as icon$4s } from '@elastic/eui/es/components/icon/assets/question_in_circle';
import { icon as icon$4t } from '@elastic/eui/es/components/icon/assets/quote';
import { icon as icon$4u } from '@elastic/eui/es/components/icon/assets/app_recently_viewed';
import { icon as icon$4v } from '@elastic/eui/es/components/icon/assets/refresh';
import { icon as icon$4w } from '@elastic/eui/es/components/icon/assets/ml_regression_job';
import { icon as icon$4x } from '@elastic/eui/es/components/icon/assets/reporter';
import { icon as icon$4y } from '@elastic/eui/es/components/icon/assets/app_reporting';
import { icon as icon$4z } from '@elastic/eui/es/components/icon/assets/return_key';
import { icon as icon$4A } from '@elastic/eui/es/components/icon/assets/save';
import { icon as icon$4B } from '@elastic/eui/es/components/icon/assets/app_saved_objects';
import { icon as icon$4C } from '@elastic/eui/es/components/icon/assets/scale';
import { icon as icon$4D } from '@elastic/eui/es/components/icon/assets/search';
import { icon as icon$4E } from '@elastic/eui/es/components/icon/assets/app_search_profiler';
import { icon as icon$4F } from '@elastic/eui/es/components/icon/assets/app_security_analytics';
import { icon as icon$4G } from '@elastic/eui/es/components/icon/assets/app_security';
import { icon as icon$4H } from '@elastic/eui/es/components/icon/assets/securitySignal';
import { icon as icon$4I } from '@elastic/eui/es/components/icon/assets/securitySignalDetected';
import { icon as icon$4J } from '@elastic/eui/es/components/icon/assets/securitySignalResolved';
import { icon as icon$4K } from '@elastic/eui/es/components/icon/assets/shard';
import { icon as icon$4L } from '@elastic/eui/es/components/icon/assets/share';
import { icon as icon$4M } from '@elastic/eui/es/components/icon/assets/snowflake';
import { icon as icon$4N } from '@elastic/eui/es/components/icon/assets/sort_down';
import { icon as icon$4O } from '@elastic/eui/es/components/icon/assets/sortLeft';
import { icon as icon$4P } from '@elastic/eui/es/components/icon/assets/sortRight';
import { icon as icon$4Q } from '@elastic/eui/es/components/icon/assets/sort_up';
import { icon as icon$4R } from '@elastic/eui/es/components/icon/assets/sortable';
import { icon as icon$4S } from '@elastic/eui/es/components/icon/assets/app_spaces';
import { icon as icon$4T } from '@elastic/eui/es/components/icon/assets/app_sql';
import { icon as icon$4U } from '@elastic/eui/es/components/icon/assets/star_empty';
import { icon as icon$4V } from '@elastic/eui/es/components/icon/assets/star_empty_space';
import { icon as icon$4W } from '@elastic/eui/es/components/icon/assets/star_filled';
import { icon as icon$4X } from '@elastic/eui/es/components/icon/assets/star_filled_space';
import { icon as icon$4Y } from '@elastic/eui/es/components/icon/assets/star_minus_empty';
import { icon as icon$4Z } from '@elastic/eui/es/components/icon/assets/star_minus_filled';
import { icon as icon$4_ } from '@elastic/eui/es/components/icon/assets/starPlusEmpty';
import { icon as icon$4$ } from '@elastic/eui/es/components/icon/assets/starPlusFilled';
import { icon as icon$50 } from '@elastic/eui/es/components/icon/assets/stats';
import { icon as icon$51 } from '@elastic/eui/es/components/icon/assets/stop';
import { icon as icon$52 } from '@elastic/eui/es/components/icon/assets/stop_filled';
import { icon as icon$53 } from '@elastic/eui/es/components/icon/assets/stop_slash';
import { icon as icon$54 } from '@elastic/eui/es/components/icon/assets/storage';
import { icon as icon$55 } from '@elastic/eui/es/components/icon/assets/string';
import { icon as icon$56 } from '@elastic/eui/es/components/icon/assets/submodule';
import { icon as icon$57 } from '@elastic/eui/es/components/icon/assets/swatch_input';
import { icon as icon$58 } from '@elastic/eui/es/components/icon/assets/symlink';
import { icon as icon$59 } from '@elastic/eui/es/components/icon/assets/table_density_compact';
import { icon as icon$5a } from '@elastic/eui/es/components/icon/assets/table_density_expanded';
import { icon as icon$5b } from '@elastic/eui/es/components/icon/assets/table_density_normal';
import { icon as icon$5c } from '@elastic/eui/es/components/icon/assets/tableOfContents';
import { icon as icon$5d } from '@elastic/eui/es/components/icon/assets/tag';
import { icon as icon$5e } from '@elastic/eui/es/components/icon/assets/tear';
import { icon as icon$5f } from '@elastic/eui/es/components/icon/assets/temperature';
import { icon as icon$5g } from '@elastic/eui/es/components/icon/assets/timeline';
import { icon as icon$5h } from '@elastic/eui/es/components/icon/assets/app_timelion';
import { icon as icon$5i } from '@elastic/eui/es/components/icon/assets/timeslider';
import { icon as icon$5j } from '@elastic/eui/es/components/icon/assets/training';
import { icon as icon$5k } from '@elastic/eui/es/components/icon/assets/trash';
import { icon as icon$5l } from '@elastic/eui/es/components/icon/assets/unfold';
import { icon as icon$5m } from '@elastic/eui/es/components/icon/assets/unlink';
import { icon as icon$5n } from '@elastic/eui/es/components/icon/assets/app_upgrade_assistant';
import { icon as icon$5o } from '@elastic/eui/es/components/icon/assets/app_uptime';
import { icon as icon$5p } from '@elastic/eui/es/components/icon/assets/user';
import { icon as icon$5q } from '@elastic/eui/es/components/icon/assets/users';
import { icon as icon$5r } from '@elastic/eui/es/components/icon/assets/app_users_roles';
import { icon as icon$5s } from '@elastic/eui/es/components/icon/assets/vector';
import { icon as icon$5t } from '@elastic/eui/es/components/icon/assets/videoPlayer';
import { icon as icon$5u } from '@elastic/eui/es/components/icon/assets/vis_area';
import { icon as icon$5v } from '@elastic/eui/es/components/icon/assets/vis_area_stacked';
import { icon as icon$5w } from '@elastic/eui/es/components/icon/assets/vis_bar_horizontal';
import { icon as icon$5x } from '@elastic/eui/es/components/icon/assets/vis_bar_horizontal_stacked';
import { icon as icon$5y } from '@elastic/eui/es/components/icon/assets/vis_bar_vertical';
import { icon as icon$5z } from '@elastic/eui/es/components/icon/assets/vis_bar_vertical_stacked';
import { icon as icon$5A } from '@elastic/eui/es/components/icon/assets/vis_gauge';
import { icon as icon$5B } from '@elastic/eui/es/components/icon/assets/vis_goal';
import { icon as icon$5C } from '@elastic/eui/es/components/icon/assets/vis_line';
import { icon as icon$5D } from '@elastic/eui/es/components/icon/assets/vis_map_coordinate';
import { icon as icon$5E } from '@elastic/eui/es/components/icon/assets/vis_map_region';
import { icon as icon$5F } from '@elastic/eui/es/components/icon/assets/vis_metric';
import { icon as icon$5G } from '@elastic/eui/es/components/icon/assets/vis_pie';
import { icon as icon$5H } from '@elastic/eui/es/components/icon/assets/vis_table';
import { icon as icon$5I } from '@elastic/eui/es/components/icon/assets/vis_tag_cloud';
import { icon as icon$5J } from '@elastic/eui/es/components/icon/assets/vis_text';
import { icon as icon$5K } from '@elastic/eui/es/components/icon/assets/vis_timelion';
import { icon as icon$5L } from '@elastic/eui/es/components/icon/assets/vis_vega';
import { icon as icon$5M } from '@elastic/eui/es/components/icon/assets/vis_visual_builder';
import { icon as icon$5N } from '@elastic/eui/es/components/icon/assets/app_visualize';
import { icon as icon$5O } from '@elastic/eui/es/components/icon/assets/app_watches';
import { icon as icon$5P } from '@elastic/eui/es/components/icon/assets/wordWrap';
import { icon as icon$5Q } from '@elastic/eui/es/components/icon/assets/wordWrapDisabled';
import { icon as icon$5R } from '@elastic/eui/es/components/icon/assets/app_workplace_search';
import { icon as icon$5S } from '@elastic/eui/es/components/icon/assets/wrench';
import { icon as icon$5T } from '@elastic/eui/es/components/icon/assets/tokenClass';
import { icon as icon$5U } from '@elastic/eui/es/components/icon/assets/tokenProperty';
import { icon as icon$5V } from '@elastic/eui/es/components/icon/assets/tokenEnum';
import { icon as icon$5W } from '@elastic/eui/es/components/icon/assets/tokenVariable';
import { icon as icon$5X } from '@elastic/eui/es/components/icon/assets/tokenMethod';
import { icon as icon$5Y } from '@elastic/eui/es/components/icon/assets/tokenAnnotation';
import { icon as icon$5Z } from '@elastic/eui/es/components/icon/assets/tokenException';
import { icon as icon$5_ } from '@elastic/eui/es/components/icon/assets/tokenInterface';
import { icon as icon$5$ } from '@elastic/eui/es/components/icon/assets/tokenParameter';
import { icon as icon$60 } from '@elastic/eui/es/components/icon/assets/tokenField';
import { icon as icon$61 } from '@elastic/eui/es/components/icon/assets/tokenElement';
import { icon as icon$62 } from '@elastic/eui/es/components/icon/assets/tokenFunction';
import { icon as icon$63 } from '@elastic/eui/es/components/icon/assets/tokenBoolean';
import { icon as icon$64 } from '@elastic/eui/es/components/icon/assets/tokenString';
import { icon as icon$65 } from '@elastic/eui/es/components/icon/assets/tokenArray';
import { icon as icon$66 } from '@elastic/eui/es/components/icon/assets/tokenNumber';
import { icon as icon$67 } from '@elastic/eui/es/components/icon/assets/tokenConstant';
import { icon as icon$68 } from '@elastic/eui/es/components/icon/assets/tokenObject';
import { icon as icon$69 } from '@elastic/eui/es/components/icon/assets/tokenEvent';
import { icon as icon$6a } from '@elastic/eui/es/components/icon/assets/tokenKey';
import { icon as icon$6b } from '@elastic/eui/es/components/icon/assets/tokenNull';
import { icon as icon$6c } from '@elastic/eui/es/components/icon/assets/tokenStruct';
import { icon as icon$6d } from '@elastic/eui/es/components/icon/assets/tokenPackage';
import { icon as icon$6e } from '@elastic/eui/es/components/icon/assets/tokenOperator';
import { icon as icon$6f } from '@elastic/eui/es/components/icon/assets/tokenEnumMember';
import { icon as icon$6g } from '@elastic/eui/es/components/icon/assets/tokenRepo';
import { icon as icon$6h } from '@elastic/eui/es/components/icon/assets/tokenSymbol';
import { icon as icon$6i } from '@elastic/eui/es/components/icon/assets/tokenFile';
import { icon as icon$6j } from '@elastic/eui/es/components/icon/assets/tokenModule';
import { icon as icon$6k } from '@elastic/eui/es/components/icon/assets/tokenNamespace';
import { icon as icon$6l } from '@elastic/eui/es/components/icon/assets/tokenDate';
import { icon as icon$6m } from '@elastic/eui/es/components/icon/assets/tokenIP';
import { icon as icon$6n } from '@elastic/eui/es/components/icon/assets/tokenNested';
import { icon as icon$6o } from '@elastic/eui/es/components/icon/assets/tokenAlias';
import { icon as icon$6p } from '@elastic/eui/es/components/icon/assets/tokenShape';
import { icon as icon$6q } from '@elastic/eui/es/components/icon/assets/tokenGeo';
import { icon as icon$6r } from '@elastic/eui/es/components/icon/assets/tokenRange';
import { icon as icon$6s } from '@elastic/eui/es/components/icon/assets/tokenBinary';
import { icon as icon$6t } from '@elastic/eui/es/components/icon/assets/tokenJoin';
import { icon as icon$6u } from '@elastic/eui/es/components/icon/assets/tokenPercolator';
import { icon as icon$6v } from '@elastic/eui/es/components/icon/assets/tokenFlattened';
import { icon as icon$6w } from '@elastic/eui/es/components/icon/assets/tokenRankFeature';
import { icon as icon$6x } from '@elastic/eui/es/components/icon/assets/tokenRankFeatures';
import { icon as icon$6y } from '@elastic/eui/es/components/icon/assets/tokenKeyword';
import { icon as icon$6z } from '@elastic/eui/es/components/icon/assets/tokenTag';
import { icon as icon$6A } from '@elastic/eui/es/components/icon/assets/tokenCompletionSuggester';
import { icon as icon$6B } from '@elastic/eui/es/components/icon/assets/tokenDenseVector';
import { icon as icon$6C } from '@elastic/eui/es/components/icon/assets/tokenText';
import { icon as icon$6D } from '@elastic/eui/es/components/icon/assets/tokenTokenCount';
import { icon as icon$6E } from '@elastic/eui/es/components/icon/assets/tokenSearchType';
import { icon as icon$6F } from '@elastic/eui/es/components/icon/assets/tokenHistogram';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var ReCookInputPopover = function (_a) {
    _a.borderRadius; var rest = __rest(_a, ["borderRadius"]);
    return jsx(EuiInputPopover, __assign({}, rest));
};
var InputPopover = styled(ReCookInputPopover)(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject(["\n  .euiFieldText {\n    ", "\n  }\n"], ["\n  .euiFieldText {\n    ", "\n  }\n"])), function (props) {
    return props.borderRadius ? "border-radius:".concat(props.borderRadius, "px;") : '';
});
var templateObject_1$9;

var Divider = function (_a) {
    var text = _a.text, rest = __rest(_a, ["text"]);
    return (jsxs("div", __assign({ className: "divider", role: "separator" }, { children: [jsx("div", __assign({ className: "divider-x" }, { children: jsx(EuiHorizontalRule, __assign({}, rest)) })), jsx(EuiText, __assign({ className: "divider-text" }, { children: jsx("p", { children: text }) })), jsx("div", __assign({ className: "divider-x" }, { children: jsx(EuiHorizontalRule, __assign({}, rest)) }))] })));
};

var AntoreeCustomizeLoading = function (_a) {
    var antoreeSize = _a.antoreeSize, loadingSize = _a.loadingSize, loadingSpinnerSize = _a.loadingSpinnerSize;
    return (jsxs("div", __assign({ style: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
        } }, { children: [jsx(EuiTitle, __assign({ size: antoreeSize || 'm' }, { children: jsxs("div", __assign({ className: "loading loading01 euiTextColor--subdued", style: { fontWeight: 400 } }, { children: [jsx("span", { children: "A" }), jsx("span", { children: "n" }), jsx("span", { children: "t" }), jsx("span", { children: "o" }), jsx("span", { children: "r" }), jsx("span", { children: "e" }), jsx("span", { children: "e" })] })) })), jsx(EuiLoadingSpinner, { size: loadingSpinnerSize || 'xl' }), jsx(EuiTitle, __assign({ size: loadingSize || 's' }, { children: jsxs("h1", __assign({ className: "loading-antoree-custom" }, { children: [jsx("span", { children: "L" }), jsx("span", { children: "o" }), jsx("span", { children: "a" }), jsx("span", { children: "d" }), jsx("span", { children: "i" }), jsx("span", { children: "n" }), jsx("span", { children: "g" }), jsx("span", { children: "." }), jsx("span", { children: "." }), jsx("span", { children: "." })] })) }))] })));
};

var ReCookStat = function (_a) {
    _a.titleFontWeight; _a.descriptionFontWeight; _a.descriptionColor; var rest = __rest(_a, ["titleFontWeight", "descriptionFontWeight", "descriptionColor"]);
    return jsx(EuiStat, __assign({}, rest));
};
var Stat = styled(ReCookStat)(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject(["\n  .euiStat__title {\n    ", "\n  }\n  .euiStat__description {\n    ", "\n    ", "\n  }\n"], ["\n  .euiStat__title {\n    ", "\n  }\n  .euiStat__description {\n    ", "\n    ", "\n  }\n"])), function (props) {
    return props.titleFontWeight ? "font-weight:".concat(props.titleFontWeight, ";") : '';
}, function (props) {
    return props.descriptionFontWeight
        ? "font-weight:".concat(props.descriptionFontWeight, ";")
        : '';
}, function (props) {
    return props.descriptionColor ? "color:".concat(props.descriptionColor, ";") : '';
});
var templateObject_1$8;

var ReCookDatePickerRange = function (_a) {
    _a.height; var rest = __rest(_a, ["height"]);
    return jsx(EuiDatePickerRange, __assign({}, rest));
};
var DatePickerRange = styled(ReCookDatePickerRange)(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject(["\n  .euiFieldText {\n    ", "\n  }\n"], ["\n  .euiFieldText {\n    ", "\n  }\n"])), function (props) { return (props.height ? "height:".concat(props.height, "px;") : ''); });
var templateObject_1$7;

var ButtonEmpty = function (_a) {
    var customIcon = _a.customIcon, children = _a.children, iconType = _a.iconType, rest = __rest(_a, ["customIcon", "children", "iconType"]);
    // eslint-disable-next-line global-require
    var Solid = require('@heroicons/react/solid');
    var IconCustomize = customIcon ? Solid[customIcon] : jsx(Fragment, {});
    return (jsx(EuiButtonEmpty, __assign({ textProps: { style: { width: '100%' } } }, rest, { iconType: customIcon
            ? function () { return (
            /* eslint-disable-next-line react/jsx-indent */
            jsx(IconCustomize, { className: "euiIcon euiIcon--medium euiButtonContent__icon" })); }
            : iconType }, { children: children })));
};

var ReCookModal = function (_a) {
    _a.maxHeight; var rest = __rest(_a, ["maxHeight"]);
    return jsx(EuiModal, __assign({}, rest));
};
var Modal = styled(ReCookModal)(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject(["\n  ", "\n  .euiModal__flex {\n    ", "\n  }\n"], ["\n  ", "\n  .euiModal__flex {\n    ", "\n  }\n"])), function (props) { return (props.maxHeight ? "margin-top:10vh;" : ''); }, function (props) { return (props.maxHeight ? "max-height:".concat(props.maxHeight, ";") : ''); });
var templateObject_1$6;

var ReCookCard = function (_a) {
    _a.marginTop; var rest = __rest(_a, ["marginTop"]);
    return jsx(EuiCard, __assign({}, rest));
};
var Card = styled(ReCookCard)(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject(["\n  .euiCard__content {\n    ", "\n  }\n"], ["\n  .euiCard__content {\n    ", "\n  }\n"])), function (props) { return (props.marginTop ? "margin-top:".concat(props.marginTop, "px;") : ''); });
var templateObject_1$5;

var ReCookComboBoxProps = function (_a) {
    _a.borderRadius; var rest = __rest(_a, ["borderRadius"]);
    return jsx(EuiComboBox, __assign({}, rest));
};
var ComboBox = styled(ReCookComboBoxProps)(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n  .euiComboBox__inputWrap {\n    ", "\n  }\n"], ["\n  .euiComboBox__inputWrap {\n    ", "\n  }\n"])), function (props) {
    return props.borderRadius ? "border-radius:".concat(props.borderRadius, "px;") : '';
});
var templateObject_1$4;

var ButtonIcon = styled(EuiButtonIcon)(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), function (props) {
    return (props.display === 'fill' || undefined) &&
        ['primary', undefined].includes(props.color)
        ? 'color: #fff !important'
        : '';
});
var templateObject_1$3;

var isModifiedEvent = function (event) { return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey); };
var isLeftClickEvent = function (event) { return event.button === 0; };
var isTargetBlank = function (event) {
    var target = event.currentTarget.getAttribute('target');
    return target && target !== '_self';
};
function Link(_a) {
    var to = _a.to, onClick = _a.onClick, rest = __rest(_a, ["to", "onClick"]);
    var history = useHistory();
    function onClickHandler(event) {
        if (event.defaultPrevented) {
            return;
        }
        // Let the browser handle links that open new tabs/windows
        if (isModifiedEvent(event) ||
            !isLeftClickEvent(event) ||
            isTargetBlank(event)) {
            return;
        }
        onClick === null || onClick === void 0 ? void 0 : onClick();
        // Prevent regular link behavior, which causes a browser refresh.
        event.preventDefault();
        // Push the route to the history.
        history.push(to);
    }
    // Generate the correct link href (with basename accounted for)
    var href = history.createHref({ pathname: to });
    return jsx(EuiLink, __assign({}, rest, { href: href, onClick: onClickHandler }));
}

var addToastHandler;
var removeAllToastsHandler;
var toastId = 0;
var TOAST_LIFE_TIME_MS = 10000;
var ToastProvider = function (_a) {
    var _b = _a.toastLifeTimeMs, toastLifeTimeMs = _b === void 0 ? TOAST_LIFE_TIME_MS : _b;
    var _c = useState([]), toasts = _c[0], setToasts = _c[1];
    var _d = useState('right'), side = _d[0], setSide = _d[1];
    addToastHandler = function (toast) {
        setToasts(function (prevState) { return __spreadArray(__spreadArray([], prevState, true), [
            __assign(__assign({}, toast), { id: "toast".concat(toastId++) }),
        ], false); });
        setSide((toast === null || toast === void 0 ? void 0 : toast.side) || 'right');
    };
    var removeToastHandler = function (removedToast) {
        setToasts(function (prevState) {
            return prevState.filter(function (toast) { return toast.id !== removedToast.id; });
        });
    };
    removeAllToastsHandler = function () {
        setToasts([]);
    };
    return (jsx(EuiGlobalToastList, { toasts: toasts, dismissToast: removeToastHandler, toastLifeTimeMs: toastLifeTimeMs, side: side, 
        /* z-index cao qua styles.scss — EuiGlobalToastList typings không có prop `style` */
        className: "antoree-global-toast-list--elevated" }));
};
var notification = {
    info: function (_a) {
        var title = _a.title, text = _a.text, side = _a.side;
        return addToastHandler({
            title: title,
            text: text,
            side: side,
            iconType: 'help',
            color: 'primary',
        });
    },
    success: function (_a) {
        var title = _a.title, text = _a.text, side = _a.side;
        return addToastHandler({
            title: title,
            text: text,
            side: side,
            iconType: 'check',
            color: 'success',
        });
    },
    warning: function (_a) {
        var title = _a.title, text = _a.text, side = _a.side;
        return addToastHandler({
            title: title,
            text: text,
            side: side,
            iconType: 'alert',
            color: 'warning',
        });
    },
    error: function (_a) {
        var title = _a.title, text = _a.text, side = _a.side;
        return addToastHandler({
            title: title,
            text: text,
            side: side,
            iconType: 'minusInCircle',
            color: 'danger',
        });
    },
};
function removeAllToasts() {
    removeAllToastsHandler();
}

var FieldPwdStyleWrapper = styled.div(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n  .euiFormControlLayout--group {\n    ", "\n  }\n  .euiFormControlLayout__append {\n    ", "\n    ", "\n  }\n"], ["\n  .euiFormControlLayout--group {\n    ", "\n  }\n  .euiFormControlLayout__append {\n    ", "\n    ", "\n  }\n"])), function (props) {
    return props.borderRaius ? "border-radius:".concat(props.borderRaius, "px;") : '';
}, function (props) {
    return props.borderRaius
        ? "border-top-right-radius:".concat(props.borderRaius, "px;")
        : '';
}, function (props) {
    return props.borderRaius
        ? "border-bottom-right-radius:".concat(props.borderRaius, "px;")
        : '';
});
var FieldPassword = React.forwardRef(function (_a, ref) {
    var borderRaius = _a.borderRaius, rest = __rest(_a, ["borderRaius"]);
    if (borderRaius) {
        return (jsx(FieldPwdStyleWrapper, __assign({ borderRaius: borderRaius }, { children: jsx(EuiFieldPassword, __assign({ inputRef: ref }, rest)) })));
    }
    return jsx(EuiFieldPassword, __assign({ inputRef: ref }, rest));
});
var templateObject_1$2;

var FormRow = function (_a) {
    var labelFontWeight = _a.labelFontWeight, children = _a.children, required = _a.required, label = _a.label, restProps = __rest(_a, ["labelFontWeight", "children", "required", "label"]);
    var labelCustom = label ? (jsxs("div", __assign({ style: {
            display: 'inline-flex',
            // eslint-disable-next-line no-unneeded-ternary
            fontWeight: labelFontWeight ? labelFontWeight : 600,
        } }, { children: [label, required && jsx("span", __assign({ style: { color: 'red' } }, { children: "\u00A0*" }))] }))) : null;
    return (jsx(EuiFormRow, __assign({ label: labelCustom }, restProps, { children: children })));
};

var Button = styled(EuiButton)(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), function (props) {
    return props.fill && ['primary', 'warning', undefined].includes(props.color)
        ? 'color: #fff !important'
        : '';
});
var templateObject_1$1;

var ButtonGroup = styled(EuiButtonGroup)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), function (props) {
    return props.color === 'primary'
        ? "label.euiButtonGroupButton.euiButtonGroupButton--primary:not([class*='isDisabled']).euiButtonGroupButton-isSelected { color:#fff }"
        : '';
});
var templateObject_1;

var Image = function (_a) {
    var className = _a.className, src = _a.src, alt = _a.alt, placeholder = _a.placeholder, rest = __rest(_a, ["className", "src", "alt", "placeholder"]);
    return (jsx(Img, __assign({ className: className, src: src, alt: alt }, rest, { placeholder: placeholder })));
};

appendIconComponentCache({
    accessibility: icon,
    addDataApp: icon$1,
    advancedSettingsApp: icon$2,
    agentApp: icon$3,
    aggregate: icon$4,
    alert: icon$5,
    analyzeEvent: icon$6,
    annotation: icon$7,
    apmApp: icon$8,
    apmTrace: icon$9,
    appSearchApp: icon$a,
    apps: icon$b,
    arrowDown: icon$c,
    arrowLeft: icon$d,
    arrowRight: icon$e,
    arrowUp: icon$f,
    asterisk: icon$g,
    auditbeatApp: icon$h,
    beaker: icon$i,
    bell: icon$j,
    bellSlash: icon$k,
    bolt: icon$l,
    boxesHorizontal: icon$m,
    boxesVertical: icon$n,
    branch: icon$o,
    broom: icon$p,
    brush: icon$q,
    bug: icon$r,
    bullseye: icon$s,
    calendar: icon$t,
    canvasApp: icon$u,
    check: icon$v,
    checkInCircleFilled: icon$w,
    cheer: icon$x,
    classificationJob: icon$y,
    clock: icon$z,
    cloudDrizzle: icon$A,
    cloudStormy: icon$B,
    cloudSunny: icon$C,
    codeApp: icon$D,
    color: icon$E,
    compute: icon$F,
    console: icon$G,
    consoleApp: icon$H,
    continuityAbove: icon$I,
    continuityAboveBelow: icon$J,
    continuityBelow: icon$K,
    continuityWithin: icon$L,
    controlsHorizontal: icon$M,
    controlsVertical: icon$N,
    copy: icon$O,
    copyClipboard: icon$P,
    createAdvancedJob: icon$Q,
    createMultiMetricJob: icon$R,
    createPopulationJob: icon$S,
    createSingleMetricJob: icon$T,
    cross: icon$U,
    crossClusterReplicationApp: icon$V,
    crossInACircleFilled: icon$W,
    crosshairs: icon$X,
    currency: icon$Y,
    cut: icon$Z,
    dashboardApp: icon$_,
    dataVisualizer: icon$$,
    database: icon$10,
    devToolsApp: icon$11,
    discoverApp: icon$12,
    document: icon$13,
    documentEdit: icon$14,
    documentation: icon$15,
    documents: icon$16,
    dot: icon$17,
    download: icon$18,
    editorAlignCenter: icon$19,
    editorAlignLeft: icon$1a,
    editorAlignRight: icon$1b,
    editorBold: icon$1c,
    editorCodeBlock: icon$1d,
    editorComment: icon$1e,
    editorDistributeHorizontal: icon$1f,
    editorDistributeVertical: icon$1g,
    editorHeading: icon$1h,
    editorItalic: icon$1i,
    editorItemAlignBottom: icon$1j,
    editorItemAlignCenter: icon$1k,
    editorItemAlignLeft: icon$1l,
    editorItemAlignMiddle: icon$1m,
    editorItemAlignRight: icon$1n,
    editorItemAlignTop: icon$1o,
    editorLink: icon$1p,
    editorOrderedList: icon$1q,
    editorPositionBottomLeft: icon$1r,
    editorPositionBottomRight: icon$1s,
    editorPositionTopLeft: icon$1t,
    editorPositionTopRight: icon$1u,
    editorRedo: icon$1v,
    editorStrike: icon$1w,
    editorTable: icon$1x,
    editorUnderline: icon$1y,
    editorUndo: icon$1z,
    editorUnorderedList: icon$1A,
    email: icon$1B,
    empty: icon$1C,
    emsApp: icon$1D,
    eql: icon$1E,
    eraser: icon$1F,
    exit: icon$1G,
    expand: icon$1H,
    expandMini: icon$1I,
    exportAction: icon$1J,
    eye: icon$1K,
    eyeClosed: icon$1L,
    faceHappy: icon$1M,
    faceNeutral: icon$1N,
    faceSad: icon$1O,
    filebeatApp: icon$1P,
    filter: icon$1Q,
    flag: icon$1R,
    fleetApp: icon$1S,
    fold: icon$1T,
    folderCheck: icon$1U,
    folderClosed: icon$1V,
    folderExclamation: icon$1W,
    folderOpen: icon$1X,
    frameNext: icon$1Y,
    framePrevious: icon$1Z,
    fullScreen: icon$1_,
    fullScreenExit: icon$1$,
    functionIcon: icon$20,
    gear: icon$21,
    gisApp: icon$22,
    glasses: icon$23,
    globe: icon$24,
    grab: icon$25,
    grabHorizontal: icon$26,
    graphApp: icon$27,
    grid: icon$28,
    grokApp: icon$29,
    heart: icon$2a,
    heartbeatApp: icon$2b,
    heatmap: icon$2c,
    help: icon$2d,
    home: icon$2e,
    iInCircle: icon$2f,
    image: icon$2g,
    importAction: icon$2h,
    indexClose: icon$2i,
    indexEdit: icon$2j,
    indexFlush: icon$2k,
    indexManagementApp: icon$2l,
    indexMapping: icon$2m,
    indexOpen: icon$2n,
    indexPatternApp: icon$2o,
    indexRollupApp: icon$2p,
    indexRuntime: icon$2q,
    indexSettings: icon$2r,
    inputOutput: icon$2s,
    inspect: icon$2t,
    invert: icon$2u,
    ip: icon$2v,
    keyboardShortcut: icon$2w,
    kqlField: icon$2x,
    kqlFunction: icon$2y,
    kqlOperand: icon$2z,
    kqlSelector: icon$2A,
    kqlValue: icon$2B,
    layers: icon$2C,
    lensApp: icon$2D,
    link: icon$2E,
    list: icon$2F,
    listAdd: icon$2G,
    lock: icon$2H,
    lockOpen: icon$2I,
    logoAWS: icon$2J,
    logoAWSMono: icon$2K,
    logoAerospike: icon$2L,
    logoApache: icon$2M,
    logoAppSearch: icon$2N,
    logoAzure: icon$2O,
    logoAzureMono: icon$2P,
    logoBeats: icon$2Q,
    logoBusinessAnalytics: icon$2R,
    logoCeph: icon$2S,
    logoCloud: icon$2T,
    logoCloudEnterprise: icon$2U,
    logoCode: icon$2V,
    logoCodesandbox: icon$2W,
    logoCouchbase: icon$2X,
    logoDocker: icon$2Y,
    logoDropwizard: icon$2Z,
    logoElastic: icon$2_,
    logoElasticStack: icon$2$,
    logoElasticsearch: icon$30,
    logoEnterpriseSearch: icon$31,
    logoEtcd: icon$32,
    logoGCP: icon$33,
    logoGCPMono: icon$34,
    logoGithub: icon$35,
    logoGmail: icon$36,
    logoGolang: icon$37,
    logoGoogleG: icon$38,
    logoHAproxy: icon$39,
    logoIBM: icon$3a,
    logoIBMMono: icon$3b,
    logoKafka: icon$3c,
    logoKibana: icon$3d,
    logoKubernetes: icon$3e,
    logoLogging: icon$3f,
    logoLogstash: icon$3g,
    logoMaps: icon$3h,
    logoMemcached: icon$3i,
    logoMetrics: icon$3j,
    logoMongodb: icon$3k,
    logoMySQL: icon$3l,
    logoNginx: icon$3m,
    logoObservability: icon$3n,
    logoOsquery: icon$3o,
    logoPhp: icon$3p,
    logoPostgres: icon$3q,
    logoPrometheus: icon$3r,
    logoRabbitmq: icon$3s,
    logoRedis: icon$3t,
    logoSecurity: icon$3u,
    logoSiteSearch: icon$3v,
    logoSketch: icon$3w,
    logoSlack: icon$3x,
    logoUptime: icon$3y,
    logoWebhook: icon$3z,
    logoWindows: icon$3A,
    logoWorkplaceSearch: icon$3B,
    logsApp: icon$3C,
    logstashFilter: icon$3D,
    logstashIf: icon$3E,
    logstashInput: icon$3F,
    logstashOutput: icon$3G,
    logstashQueue: icon$3H,
    machineLearningApp: icon$3I,
    magnet: icon$3J,
    magnifyWithMinus: icon$3K,
    magnifyWithPlus: icon$3L,
    managementApp: icon$3M,
    mapMarker: icon$3N,
    memory: icon$3O,
    menu: icon$3P,
    menuDown: icon$3Q,
    menuLeft: icon$3R,
    menuRight: icon$3S,
    menuUp: icon$3T,
    merge: icon$3U,
    metricbeatApp: icon$3V,
    metricsApp: icon$3W,
    minimize: icon$3X,
    minus: icon$3Y,
    minusInCircle: icon$3Z,
    minusInCircleFilled: icon$3_,
    mobile: icon$3$,
    monitoringApp: icon$40,
    moon: icon$41,
    nested: icon$42,
    node: icon$43,
    notebookApp: icon$44,
    number: icon$45,
    offline: icon$46,
    online: icon$47,
    outlierDetectionJob: icon$48,
    packageIcon: icon$49,
    packetbeatApp: icon$4a,
    pageSelect: icon$4b,
    pagesSelect: icon$4c,
    paperClip: icon$4d,
    partial: icon$4e,
    pause: icon$4f,
    pencil: icon$4g,
    percent: icon$4h,
    pin: icon$4i,
    pinFilled: icon$4j,
    pipelineApp: icon$4k,
    play: icon$4l,
    playFilled: icon$4m,
    plus: icon$4n,
    plusInCircle: icon$4o,
    plusInCircleFilled: icon$4p,
    popout: icon$4q,
    push: icon$4r,
    questionInCircle: icon$4s,
    quote: icon$4t,
    recentlyViewedApp: icon$4u,
    refresh: icon$4v,
    regressionJob: icon$4w,
    reporter: icon$4x,
    reportingApp: icon$4y,
    returnKey: icon$4z,
    save: icon$4A,
    savedObjectsApp: icon$4B,
    scale: icon$4C,
    search: icon$4D,
    searchProfilerApp: icon$4E,
    securityAnalyticsApp: icon$4F,
    securityApp: icon$4G,
    securitySignal: icon$4H,
    securitySignalDetected: icon$4I,
    securitySignalResolved: icon$4J,
    shard: icon$4K,
    share: icon$4L,
    snowflake: icon$4M,
    sortDown: icon$4N,
    sortLeft: icon$4O,
    sortRight: icon$4P,
    sortUp: icon$4Q,
    sortable: icon$4R,
    spacesApp: icon$4S,
    sqlApp: icon$4T,
    starEmpty: icon$4U,
    starEmptySpace: icon$4V,
    starFilled: icon$4W,
    starFilledSpace: icon$4X,
    starMinusEmpty: icon$4Y,
    starMinusFilled: icon$4Z,
    starPlusEmpty: icon$4_,
    starPlusFilled: icon$4$,
    stats: icon$50,
    stop: icon$51,
    stopFilled: icon$52,
    stopSlash: icon$53,
    storage: icon$54,
    string: icon$55,
    submodule: icon$56,
    swatchInput: icon$57,
    symlink: icon$58,
    tableDensityCompact: icon$59,
    tableDensityExpanded: icon$5a,
    tableDensityNormal: icon$5b,
    tableOfContents: icon$5c,
    tag: icon$5d,
    tear: icon$5e,
    temperature: icon$5f,
    timeline: icon$5g,
    timelionApp: icon$5h,
    timeslider: icon$5i,
    training: icon$5j,
    trash: icon$5k,
    unfold: icon$5l,
    unlink: icon$5m,
    upgradeAssistantApp: icon$5n,
    uptimeApp: icon$5o,
    user: icon$5p,
    users: icon$5q,
    usersRolesApp: icon$5r,
    vector: icon$5s,
    videoPlayer: icon$5t,
    visArea: icon$5u,
    visAreaStacked: icon$5v,
    visBarHorizontal: icon$5w,
    visBarHorizontalStacked: icon$5x,
    visBarVertical: icon$5y,
    visBarVerticalStacked: icon$5z,
    visGauge: icon$5A,
    visGoal: icon$5B,
    visLine: icon$5C,
    visMapCoordinate: icon$5D,
    visMapRegion: icon$5E,
    visMetric: icon$5F,
    visPie: icon$5G,
    visTable: icon$5H,
    visTagCloud: icon$5I,
    visText: icon$5J,
    visTimelion: icon$5K,
    visVega: icon$5L,
    visVisualBuilder: icon$5M,
    visualizeApp: icon$5N,
    watchesApp: icon$5O,
    wordWrap: icon$5P,
    wordWrapDisabled: icon$5Q,
    workplaceSearchApp: icon$5R,
    wrench: icon$5S,
    tokenClass: icon$5T,
    tokenProperty: icon$5U,
    tokenEnum: icon$5V,
    tokenVariable: icon$5W,
    tokenMethod: icon$5X,
    tokenAnnotation: icon$5Y,
    tokenException: icon$5Z,
    tokenInterface: icon$5_,
    tokenParameter: icon$5$,
    tokenField: icon$60,
    tokenElement: icon$61,
    tokenFunction: icon$62,
    tokenBoolean: icon$63,
    tokenString: icon$64,
    tokenArray: icon$65,
    tokenNumber: icon$66,
    tokenConstant: icon$67,
    tokenObject: icon$68,
    tokenEvent: icon$69,
    tokenKey: icon$6a,
    tokenNull: icon$6b,
    tokenStruct: icon$6c,
    tokenPackage: icon$6d,
    tokenOperator: icon$6e,
    tokenEnumMember: icon$6f,
    tokenRepo: icon$6g,
    tokenSymbol: icon$6h,
    tokenFile: icon$6i,
    tokenModule: icon$6j,
    tokenNamespace: icon$6k,
    tokenDate: icon$6l,
    tokenIP: icon$6m,
    tokenNested: icon$6n,
    tokenAlias: icon$6o,
    tokenShape: icon$6p,
    tokenGeo: icon$6q,
    tokenRange: icon$6r,
    tokenBinary: icon$6s,
    tokenJoin: icon$6t,
    tokenPercolator: icon$6u,
    tokenFlattened: icon$6v,
    tokenRankFeature: icon$6w,
    tokenRankFeatures: icon$6x,
    tokenKeyword: icon$6y,
    tokenTag: icon$6z,
    tokenCompletionSuggester: icon$6A,
    tokenDenseVector: icon$6B,
    tokenText: icon$6C,
    tokenTokenCount: icon$6D,
    tokenSearchType: icon$6E,
    tokenHistogram: icon$6F,
});

var baseColors = {
    failure: '#ED4B9E',
    primary: '#14B24C',
    primaryLight: 'rgba(20, 178, 76, 0.15)',
    primaryDark: '#14B24C',
    secondary: '#7645D9',
    success: '#31D0AA',
    warning: '#FFB237',
    subdued: '#69707D',
    danger: '#ED0000',
    subduedLight: 'rgba(52, 55, 65, 0.15)',
};

// Please do not use types off of a default export module or else Storybook Docs will suffer.
// see: https://github.com/storybookjs/storybook/issues/9556
/**
 * A custom Thing component. Neat!
 */
var Thing = function (_a) {
    var children = _a.children;
    // eslint-disable-next-line prettier/prettier
    return jsx("div", { children: children || "the snozzberries taste like snozzberries" });
};

export { AntoreeCustomizeLoading, Button, ButtonEmpty, ButtonGroup, ButtonIcon, Card, ComboBox, DatePickerRange, Divider, FieldPassword, FormRow, Image as Img, InputPopover, Link, Modal, Stat, Thing, ToastProvider, baseColors, notification, removeAllToasts };
